export default __webpack_public_path__ + "static/media/RoundGradInfluencing.d179bc22.svg";